<template>
  <div>
    <div class="echarts" :style="`height: ${height}; min-height: 360px`" >
      <v-chart :option='options' :resizable="true" theme="infographic"></v-chart>
    </div>
  </div>
</template>

<script>
import {
  store
} from '@/scripts/store.js'
import IEcharts from 'vue-echarts-v3/src/full.js'

const _ = require('lodash')

export default {
  name: 'VariantDataSampleDemoGraphics',
  components: {
    'v-chart': IEcharts,
  },
  data() {
    return {
      store: store,
      options: {},
      show: false,
    }
  },
  props: {
    height: String,
    plotdata: Array,
  },
  async mounted() {
    const context = this
    this.loadChart()
  },
  methods: {
    loadChart: function () {
      const context = this

      const data = _.filter(context.plotdata, d => {
        return d.age !== "Unknown"
      })
      const numFiltered = _.sum(_.map(data, 'genderCount'))
      const numTotal = _.sum(_.map(context.plotdata, 'genderCount'))
      const genders = _.uniq(_.map(context.plotdata, 'gender'))
      const ages = _.uniq(_.map(data, 'age')).sort((a, b) => {
        return a - b
      })
      const xLabels = _.map(ages, a => {
        return `${a}-${a+10}`
      })

      console.log(`Plotting Sample Demographics: ${numFiltered} of ${numTotal} have valid age value. Samples with unknown age are ignored.`)

      const labels = []
      const series = []

      genders.forEach((gender, id) => {
        const genderData = _.filter(data, d => {
          return d.gender == gender;
        })
        const y = []
        ages.forEach(age => {
          const d = _.filter(genderData, g => {
            return g.age === age;
          })
          if (d.length > 0) {
            y.push(d[0].genderCount)
          } else {
            y.push(0)
          }
        })
        if (_.sum(y) > 0) {
          series.push({
            type: 'bar',
            name: gender,
            stack: 'Samples',
            data: y,
            xAxisIndex: 0,
            yAxisIndex: 0,
            color: store.theme.colors['gender'][gender],
          })
          series.push({
            type: 'bar',
            name: gender,
            stack: 'Total',
            data: [((_.sum(y) / numFiltered) * 100).toFixed(2)],
            color: store.theme.colors['gender'][gender],
            xAxisIndex: 1,
            yAxisIndex: 1,
          })
        }
      })

      context.options = {
        textStyle: {
          fontFamily: store.theme.fontFamily.content ,fontWeight: 'bold'
        },
        cursor: 'default',
        grid: [
          { left: 50, bottom: 50, top: 50, width: '75%' },
          { left: '86%', bottom: 50, top: 50, right: 30, width: '7%' }
        ],
        legend: { data: genders, left: 10 },
        tooltip: {
          show: true, trigger: 'axis', axisPointer: { type: 'shadow' }, confine: true,
          textStyle: {
            fontFamily: store.theme.fontFamily.plotTooltip,
            color: '#4e4e4e', fontWeight: 'normal'
          }, backgroundColor: 'white', padding: 10,
        },
        toolbox: {
          top: 0, right: 5, itemSize: 12,
          iconStyle: { borderColor: '#4e4e4e' },
          feature: {
            saveAsImage: {
              title: 'Save as PNG', show: true, type: 'png',
              name: 'AgeHistogram_StackedBar', excludeComponents: ['toolbox']
            },
            dataView: {
              title: 'View data', readOnly: true,
              lang: ['Data View', 'Go back']
            },
          }
        },
        xAxis: [{
            name: 'Age', nameLocation: 'center', nameGap: 35,
            data: xLabels, gridIndex: 0, axisLine: { show: false },
            axisLabel: { interval: 0, rotate: 25 }, axisTick: { interval: 0 }
          },
          {
            data: ['Total'], gridIndex: 1, axisLine: { show: false },
          }
        ],
        yAxis: [
          {
            gridIndex: 0, name: '#Samples', nameLocation: 'middle',
            nameGap: 35, splitLine: { show: false }, axisLabel: { interval: 1 },
            axisLine: { show: false },
          },
          {
            min: 0, max: 100, gridIndex: 1, position: 'right', splitNumber: 2,
            offset: -4, name: 'Percentage', nameGap: 8, nameTextStyle: { align: 'right' },
            axisLine: { show: false },
          }
        ],
        resize: true, animation: true, series: series,
      }
    }
  },
}
</script>

<style>
  
</style>